(function () {
  function toNumber(value) {
    var parsed = Number.parseFloat(String(value || '').replace(/,/g, '').trim());
    if (Number.isNaN(parsed) || parsed < 0) {
      return 0;
    }
    return parsed;
  }

  function formatRounded(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function initCalculator(root) {
    var scope = root || document;
    var calculators = scope.querySelectorAll('[data-income-calculator]');

    calculators.forEach(function (calculator) {
      if (calculator.dataset.calculatorReady === 'true') {
        return;
      }
      calculator.dataset.calculatorReady = 'true';

      var button = calculator.querySelector('[data-calculate-income]');
      var monthOutput = calculator.querySelector('[data-price-per-month]');
      var yearOutput = calculator.querySelector('[data-price-per-year]');
      var sessionsInput = calculator.querySelector('input[name="sessions"]');
      var daysInput = calculator.querySelector('input[name="days"]');
      var weeksInput = calculator.querySelector('input[name="weeks"]');
      var chargeInput = calculator.querySelector('input[name="charge"]');

      if (!button || !monthOutput || !yearOutput || !sessionsInput || !daysInput || !weeksInput || !chargeInput) {
        return;
      }

      function calculate() {
        var spd = toNumber(sessionsInput.value);
        var dpw = toNumber(daysInput.value);
        var wpy = toNumber(weeksInput.value);
        var sc = toNumber(chargeInput.value);

        var annualIncome = spd * dpw * wpy * sc;
        var monthlyIncome = annualIncome / 12;

        monthOutput.textContent = formatRounded(monthlyIncome);
        yearOutput.textContent = formatRounded(annualIncome);
      }

      button.addEventListener('click', calculate);

      [sessionsInput, daysInput, weeksInput, chargeInput].forEach(function (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            calculate();
          }
        });
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCalculator(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCalculator(document);
    });
  } else {
    initCalculator(document);
  }
})();
